import { Controller } from 'stimulus'
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ['providerSelect']
  static values = { url: String }

  update() {
    let params = new URLSearchParams()
    params.append('provider_id', event.target.value)

    get(`${this.urlValue}?${params}`, {
      responseKind: 'turbo-stream'
    })
  }
}
